import { render } from "./ChangePasswordPage.vue?vue&type=template&id=1f803344&scoped=true&ts=true"
import script from "./ChangePasswordPage.vue?vue&type=script&lang=ts"
export * from "./ChangePasswordPage.vue?vue&type=script&lang=ts"

import "./ChangePasswordPage.vue?vue&type=style&index=0&id=1f803344&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f803344"]])

export default __exports__